import React, { useState, useRef, useEffect } from "react";
import { styled } from "../../stitches.config";
import useMediaQuery from "../../helpers/useMediaQuery";

interface ITextWrapper {
    children: React.ReactNode;
}

const TextWrapper: React.FC<ITextWrapper> = ({ children }) => {
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    const isDesktop = useMediaQuery("bp4");

    useEffect(() => {
        if (contentRef.current) {
            const limit = isDesktop ? 150 : 100;
            setIsOverflowing(contentRef.current.scrollHeight > limit);
        }
    }, [children, isDesktop]);

    return (
        <Wrapper>
            <Content
                ref={contentRef}
                expanded={expanded}
                showGradient={isOverflowing && !expanded}
            >
                {children}
            </Content>

            {isOverflowing && !expanded && (
                <ToggleButton onClick={() => setExpanded(true)}>
                    Pokaż więcej
                </ToggleButton>
            )}
        </Wrapper>
    );
};

export default TextWrapper;

const Wrapper = styled("div", {
    position: "relative",
});

const Content = styled("div", {
    overflow: "hidden",
    position: "relative",
    transition: "max-height 0.3s ease",

    maxHeight: "100px",
    "@bp4": {
        maxHeight: "150px",
    },

    variants: {
        expanded: {
            true: {
                maxHeight: "4000px",
            },
        },
        showGradient: {
            true: {
                "&::after": {
                    content: "",
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "40px",
                    background:
                        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, $grayscale100Fixed 100%)",
                    pointerEvents: "none",
                    transition: "opacity 0.3s ease",
                },
            },
            false: {},
        },
    },
});

const ToggleButton = styled("button", {
    marginTop: "12px",
    color: "$primary",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",

    "&:hover": {
        opacity: 0.8,
    },
});
